import useTypedSelector from 'common/hooks/useTypedSelector';
import FetchStatus from 'common/types/FetchStatus';
import React from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';

interface IPrivateRoute extends RouteProps {
  children?: never;
}

const PrivateRoute = (props: IPrivateRoute) => {
  const { authenticated } = useTypedSelector((state) => ({
    authenticated:
      state.auth.fetchStatus === FetchStatus.loaded &&
      state.auth.access_token !== null,
  }));

  const { component, ...rest } = props;

  return (
    <Route
      {...rest}
      render={() => {
        return authenticated ? (
          React.createElement(component as React.ComponentClass)
        ) : (
          <Redirect to='/auth/login' />
        );
      }}
    />
  );
};

export default PrivateRoute;
